import React, { useEffect, useState } from "react";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import { directUrl, homePageUrl } from "../../../helpers/Constants";
import { useParams } from "react-router-dom";
import { requestApi } from "../../../request-api";
import { FaCheckCircle } from "react-icons/fa";
import ReactCodeInput from "react-code-input";
import { useLocation, useNavigate } from 'react-router-dom';


function CompliancerLegislationList() {
  const [modal, setModal] = useState(false);
  const loginForm = () => setModal(!modal);
  let location = useLocation();

  let [legislation, setLegislation] = useState([]);
  let [legislationName, setLegislationName] = useState([]);
  let [phone, setPhone] = useState('');
  let { reportId } = useParams();
  const [otpError, setOtpError] = useState('')
  const [code, setCode] = useState('')
  const [count, setCount] = useState('')
  const [reportStatus,setReportStatus]=useState('')
  let navigate = useNavigate()
  let countData = 0;
  const getListlationStatus=(legislationId)=>{
    requestApi(`/auditor/legislation/legislationStatus/${legislationId}`,{
      method:'get',
  }).then((data)=>{
    if(data.statusCode === 200){
      console.log("Legislation status updated>> ",data.data)
    }    
    else{
      console.log("Legislation status updated>> ",data.data)
    }
  }).catch((error)=>{
      console.log("Error",error)
  })
}

  const getComplianceData = () => {
    requestApi(`/compliancer/getLegislationByReport/${reportId}`, {
      method: "get",
    })
      .then((data) => {
        console.log("first", data.report_status);
        setLegislation(data.data);
        setReportStatus(data.report_status)
        let legName = [];
        let count = 0
        data.data.map((leg) => {
          legName.push(leg.legislation_name);
          if(leg.status == 0)
          {
            count = count + 1
          }
         

        });
        setLegislationName(legName);
        setCount(count)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getReportStatus = () => {
    requestApi(`/report/reportStatus/${reportId}`, {
      method: "get",
    })
      .then((data) => {
        if (data.statusCode === 200) {
            navigate(`${directUrl}compliancer/report-submitted-successfully`);  
          console.log("Legislation status updated>> ", data.data);
        } else {
          console.log("Legislation status updated>> ", data.data);
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  useEffect(() => {
    getComplianceData();
    
    userData();
  }, []);

  const userData = () => {
    requestApi(`/superadmin/userData`, {
      method: "get",
    })
      .then((data) => {
        if (data.statusCode === 200) {
            setPhone(data.data.phone_number)
          console.log("Users data ", data.data.phone_number);
        } else {
          console.log("uset data ", data.data);
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  const sendOtp = async () => {
    console.debug('sending code')
    // save code to be able to resend it
    // this.phone = phone
    const loginRequest = await requestApi('/sendOTP/loginUser',{
      method:'post',
      body: JSON.stringify({
        phone_number:phone
      })
    })

    console.log("--------->PHONE",loginRequest)
   }

   const submitEvent = async ()=>{  
    console.log("code is >>>",phone)
    requestApi(`/checkOtpOnReport`, {
        method: "post",
        body: JSON.stringify({
            phone_number:phone,
            otp:code
          })
      })
        .then((data) => {
            if(data.statusCode == 200)
            {
                setModal(false)
                getReportStatus();
                console.log("Report data 200>>>", data)
            }
            else{
                setOtpError(data.message)
                console.log("Report data>>>", data)
            }
        })
        .catch((error) => {
          console.log("Error", error);
        });
   }

  return (
    <section className="lyt-section">
      <Container fluid className="typ-container">
        <Breadcrumb className="bs-breadcrumb mt-0">
          <BreadcrumbItem>
            <NavLink to={`${directUrl}compliancer/reports`}>Reports</NavLink>
          </BreadcrumbItem>
          {console.log(location.state)}
          <BreadcrumbItem active>{location.state?.row.report_id}</BreadcrumbItem>
          <BreadcrumbItem active>Legislation</BreadcrumbItem>
        </Breadcrumb>
        <Row>
          <Col xs={12} sm={12} md={12} lg={9} xl={8}>
            <ul className="bs-list">
              {legislation.map((leg,index) => {
                
                getListlationStatus(leg.id)
                if(countData < 1 && legislation.length == index+1){
                  userData()
                  console.log("======================================")
                  countData +=1
                }
                
                return(
                <li>
                  <NavLink
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `${directUrl}compliancer/legislation-list/${reportId}/${leg.id}`,
                        { state: { leg: leg, row: location.state.row } }
                      );
                    }}
                    // to={`${directUrl}compliancer/legislation-list/${reportId}/${leg.id}`}
                  >
                    {leg.legislation_name}{' '}
                  </NavLink>
                  {leg.status == 1 ? <FaCheckCircle /> : ''}
                </li>
              )})}
              <Button
                color="success"

                style={{margin:'10px'}}
                disabled={count == 0 && reportStatus == false ? false : true}
                onClick={(e) => {
                  loginForm();
                  sendOtp();
                }}
              >
                Submit
              </Button>
            </ul>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={modal} toggle={loginForm} centered={true}>
        {/* <ModalHeader toggle={loginForm}>Modal title</ModalHeader> */}
        <ModalBody>
          <form className="bs-form">
            <p className="otp-desc">Enter the 6-digit code send to {phone} </p>

            <div className="input-area">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginbottom: 50,
                }}
              >
                <ReactCodeInput
                  type="tel"
                  fields={6}
                  className="ReactCodeInput otp-input-wrapper"
                  inputStyle={{
                    fontFamily: 'roboto',
                    MozAppearance: 'textfield',
                    width: '41px',
                    borderRadius: '5px',
                    fontSize: '20px',
                    height: '41px',
                    paddingLeft: '0px',
                    backgroundColor: 'white',
                    border: '1px solid rgba(0,0,0,0.4)',
                    outline: 'none',
                    textAlign: 'center',
                    margin: '2px',
                  }}
                  id="code"
                  placeholder={'123456'}
                  onChange={(value) => setCode(value)}
                  required
                />
              </div>
            </div>
            {otpError && (
              <p
                style={{
                  position: 'absolute',
                  fontSize: '12px',
                  color: '#d73038',
                  margin: '10px 10px',
                  fontFamily: 'roboto',
                  fontWeight: 500,
                }}
              >
                {otpError}
              </p>
            )}

            <button
              style={{ marginTop: 30 }}
              className="bs-btn typ-login"
              type="button"
              onClick={(e) => {
                submitEvent();
              }}
            >
              Sign In
            </button>
          </form>
        </ModalBody>
      </Modal>
    </section>
  );
}

export default CompliancerLegislationList;
